<!--用户中心中转站-->
<template>
  <div>
    <!--用户中心主体-->
    <Wrap v-if="storeInfo.storeId>0||storeInfo.type==99||storeInfo.type==2"></Wrap>
    <!--销售先选择酒店页面-->
    <ChooseHotel v-else  ref="chooseHotel"></ChooseHotel>
  </div>
</template>

<script>
import { mapGetters, mapActions,mapState } from 'vuex'
import Wrap from './Wrap.vue'
import ChooseHotel from './Components/ChooseHotel.vue'

export default {
    name: 'UserCenter',
    components: { Wrap,ChooseHotel},
    props: {},
    data() {
        return {
        };
    },
    computed: {
        ...mapState(['userLoginMessage','newMessageInform']),
        ...mapGetters(['storeInfo',]),
    },
    watch: {
      newMessageInform (newVal) {
        //解除关联审核通过刷新订单列表
        if(newVal && newVal.type === 54){
          //在门店列表、申请列表-已解除、申请列表-已拒绝 刷新列表
             this.POST_UnionRecordSaleList({data:{},successFun:(res)=>{}});
        }
      },
    },
    created() {},
    mounted() {},
    methods: {
       ...mapActions(['POST_UnionRecordSaleList']),
    }
};
</script>

<style lang="scss" scoped>
body{
  background-color: #f3f4f8;
}
</style>
